import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/contexts/AuthContext";
import { Label } from "@/components/ui/label";
import { MultiSelectDropdown } from "@/components/MultiSelectDropdown";

// Vertical + onboarding programs a production workbook belongs to.
// value: { vertical_key, product_ids }  onChange(next)
export function ProductionLinksPicker({ value, onChange, testId = "prod-links", compact = false }) {
  const [catalog, setCatalog] = useState(null);
  useEffect(() => { api.get("/onboarding/catalog").then(({ data }) => setCatalog(data)).catch(() => setCatalog({ verticals: [], products: [], mappings: [] })); }, []);
  const vertical = catalog?.verticals.find((v) => v.key === value.vertical_key);
  const products = useMemo(() => {
    if (!catalog) return [];
    const allowed = vertical ? new Set(catalog.mappings.filter((m) => m.vertical_id === vertical.id).map((m) => m.product_id)) : null;
    return catalog.products.filter((p) => p.active !== false && (!allowed || allowed.has(p.id)));
  }, [catalog, vertical]);
  if (!catalog) return <div className="text-[11px] text-[#6C757D]">Loading programs…</div>;
  return (
    <div className={`grid grid-cols-1 ${compact ? "sm:grid-cols-[180px_1fr]" : "sm:grid-cols-2"} gap-2`} data-testid={testId}>
      <div>
        {!compact && <Label className="text-xs">Vertical</Label>}
        <select
          value={value.vertical_key || ""}
          onChange={(e) => onChange({ vertical_key: e.target.value || null, product_ids: [] })}
          className="w-full h-9 rounded-sm border-2 border-[#E9ECEF] bg-white px-2 text-xs font-semibold text-[#0B132B] focus:border-[#D4AF37] outline-none"
          data-testid={`${testId}-vertical`}
        >
          <option value="">Any vertical</option>
          {catalog.verticals.filter((v) => v.active !== false).map((v) => <option key={v.key} value={v.key}>{v.name}</option>)}
        </select>
      </div>
      <div>
        {!compact && <Label className="text-xs">Programs this workbook installs</Label>}
        <MultiSelectDropdown
          testId={`${testId}-programs`}
          placeholder="Pick program(s)…"
          options={products.map((p) => ({ key: p.id, label: p.name, hint: p.short_name || undefined }))}
          selected={value.product_ids || []}
          onToggle={(key) => {
            const cur = value.product_ids || [];
            onChange({ ...value, product_ids: cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key] });
          }}
          onSelectAll={(on) => onChange({ ...value, product_ids: on ? products.map((p) => p.id) : [] })}
        />
      </div>
    </div>
  );
}
